import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Snackbar,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { changePassword } from "../redux/actions/AdminAction";
import { CHANGE_PASSWORD_RESET, SEND_OTP_RESET } from "../Constants/Constants";

const NavLinkButton = styled(Button)(({ theme }) => ({
  textDecoration: "none",
  color: "black",
  padding: 10,
  fontFamily: ["Roboto", "sans-serif"].join(","),
  fontOpticalSizing: "auto",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: 20,
}));

export default function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user_id = JSON.parse(localStorage.getItem("user_id"));

  const [snackOpen, setSnackOpen] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  const new_password = useRef();
  const confirm_password = useRef();
  const otp = useRef();

  const SendOTPData = useSelector((state) => state.SendOTPData);
  const { sendOTPerror, sendOTPInfo } = SendOTPData;

  const ChangeUserPassword = useSelector((state) => state.ChangeUserPassword);
  const {
    success: changePasswordSuccess,
    message: changePasswordMessage,
    changePasswordError,
  } = ChangeUserPassword;

  useEffect(() => {
    dispatch({ type: CHANGE_PASSWORD_RESET });
    setSnackOpen(true);
  }, []);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowOTP = () => setShowOTP((show) => !show);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setSnackOpen(true);
    const change_password_data = {
      otp: otp.current.value,
      new_password: new_password.current.value,
    };
    dispatch(changePassword(user_id, change_password_data));
    dispatch({ type: SEND_OTP_RESET });
    setTimeout(() => {
      if (new_password.current) {
        new_password.current.value = "";
      }
      if (confirm_password.current) {
        confirm_password.current.value = "";
      }
      if (otp.current) {
        otp.current.value = "";
      }
    }, 5000);
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box
        sx={{
          mt: 10,
        }}
      >
        <Grid container spacing={3} sx={{ textAlign: "center" }}>
          <Grid xs={12}>
            <Typography
              sx={{
                fontSize: 30,
                textAlign: "center",
                ml: 3,
                color: "#313639",
              }}
            >
              Change password
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <OutlinedInput
              required
              size="medium"
              sx={{ width: "35%", height: "8vh" }}
              type={showOTP ? "text" : "password"}
              inputRef={otp}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowOTP}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showOTP ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              }
              placeholder="One Time Password (OTP)"
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <FormControl variant="outlined" size="medium" sx={{ width: "35%" }}>
              <OutlinedInput
                required
                sx={{ height: "8vh" }}
                type={showNewPassword ? "text" : "password"}
                inputRef={new_password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowNewPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showNewPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                placeholder="New Password"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <FormControl variant="outlined" size="medium" sx={{ width: "35%" }}>
              <OutlinedInput
                required
                sx={{ height: "8vh" }}
                type={showConfirmPassword ? "text" : "password"}
                inputRef={confirm_password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowConfirmPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                placeholder="Confirm Password"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ fontSize: 40, textAlign: "center" }}>
            <Button
              type="submit"
              onClick={handleChangePassword}
              size="small"
              sx={{
                backgroundColor: "#282828",
                border: "1px solid #313639",
                color: "#ffffff",
                width: "35vh",
                height: "8vh",
                mt: 4,
                fontSize: 18,
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
            >
              Change Password
            </Button>
          </Grid>
          {changePasswordSuccess && changePasswordMessage && (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <NavLinkButton onClick={() => navigate("/")}>LOGIN</NavLinkButton>
            </Grid>
          )}
        </Grid>

        {sendOTPerror && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {sendOTPerror}
            </Alert>
          </Snackbar>
        )}
        {sendOTPInfo && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              {sendOTPInfo}
            </Alert>
          </Snackbar>
        )}
        {changePasswordSuccess && changePasswordMessage && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              {changePasswordMessage}
            </Alert>
          </Snackbar>
        )}
        {changePasswordError && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {changePasswordError}
            </Alert>
          </Snackbar>
        )}
      </Box>
    </Container>
  );
}
